import Nav from "../components/nav";
import Forms from "../components/forms";

export default {
  init() {
    new Nav();
    new Forms();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js